import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import TitleField from '../../fields/TitleField';
import MatureContentField from '../../fields/MatureContentField';
import DescriptionField from '../../fields/DescriptionField';
import PriceField from '../../fields/PriceField';
import DisplayOptionsField from '../../fields/DisplayOptionsField';
import OpenForOrdersField from '../../fields/OpenForOrdersField';
import CategoryField from '../../fields/CategoryField';
import GalleryField from '../../fields/GalleryField';
import TagsField from '../../fields/TagsField';
import ShippingProfileField from '../../fields/ShippingProfileField';

import s from './FirstStep.scss';

interface Props {
  deviation?: PapiDeviation;
}

const FirstStep: React.FC<Props> = ({ deviation }) => {
  const showDisplayOptions = deviation && !deviation.isDefaultImage;
  return (
    <div className={s['root']}>
      <OpenForOrdersField />
      <div data-field="title">
        <TitleField />
      </div>
      <div data-field="category">
        <CategoryField />
      </div>
      <MatureContentField />
      {showDisplayOptions && <DisplayOptionsField deviation={deviation} />}
      <div data-field="description">
        <DescriptionField />
      </div>
      <GalleryField />
      <div data-field="price">
        <PriceField />
      </div>
      <TagsField />
      <div data-field="shippingProfile">
        <ShippingProfileField />
      </div>
    </div>
  );
};
FirstStep.displayName = 'FirstStep';

export default FirstStep;
